import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Constant Program Planning',
  description: 'You spend hours every week creating workouts, adjusting training loads, and organizing sessions for runners with completely different goals and fitness levels.'
}, {
  emoji: '⚠️',
  title: 'Fear Of Doing Too Much... Or Too Little',
  description: 'You constantly wonder if your athletes are training enough to improve — or too much and heading toward injury, fatigue, or burnout.'
}, {
  emoji: '📚',
  title: 'Information Everywhere',
  description: 'You find training methods, interval systems, and coaching advice everywhere, but nothing is organized into one complete system you can follow with confidence.'
}, {
  emoji: '😩',
  title: 'Mental Exhaustion',
  description: "Between planning workouts, tracking progress, adjusting programs, and answering athlete questions, there's little time left to focus on helping runners achieve their goals."
}];
export function PainSection() {
  return <section className="py-10 px-4 sm:px-6 bg-white border-b border-gray-200" data-id="element-127">
      <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-navy mb-3 uppercase leading-tight" data-id="element-128">
        DO YOU RECOGNIZE THIS?
      </h2>

      <p className="text-sm sm:text-base text-brand-ink/80 font-medium text-center mb-8 leading-snug max-w-2xl mx-auto" data-id="element-129">
        You love coaching runners, but does planning consume your entire week?
        <span className="text-brand-orange font-bold mt-2 block" data-id="element-130">
          If you're a running coach, endurance coach, athletics instructor, or
          personal trainer working with runners, you probably know one of these
          situations:
        </span>
      </p>

      <div className="flex flex-col gap-4 max-w-2xl mx-auto" data-id="element-131">
        {pains.map((pain, i) => <div key={i} className="bg-brand-paper p-5 rounded-lg border-l-4 border-brand-red shadow-md flex gap-4 items-start" data-id="element-132">
            <div className="text-3xl leading-none shrink-0 mt-1" data-id="element-133">
              {pain.emoji}
            </div>
            <div data-id="element-134">
              <h3 className="text-base font-bold text-brand-navy mb-1.5 uppercase tracking-tight" data-id="element-135">
                {pain.title}
              </h3>
              <p className="text-brand-ink/70 text-sm leading-relaxed" data-id="element-136">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}